import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';

export default function numberToByteQuantifiedStringConverter(bytes: number): string {
    let formatString: string;
    if (bytes >= 0x40000000) {
        // GB
        bytes /= 0x40000000;
        formatString = strings.sizeWithGigabyteAbbreviationText;
    } else if (bytes >= 0x100000) {
        // MB
        bytes /= 0x100000;
        formatString = strings.sizeWithMegabyteAbbreviationText;
    } else if (bytes >= 0x400) {
        // KB
        bytes /= 0x400;
        formatString = strings.sizeWithKilobyteAbbreviationText;
    } else {
        formatString = strings.sizeWithByteAbbreviationText;
    }

    return format(formatString, Math.round(bytes));
}
